<template>
  <div class="page-wrapper">
    <div class="tiles d-flex flex-row pa-2">
      <div class="tile-wrapper" v-for="(tile, index) in tiles" :key="index">
        <header-tile :icon="tile.icon" :count="tile.count" :name="tile.name" />
      </div>
    </div>
    <div class="actions d-flex flex-row align-center pr-2 pl-2">
      <ul class="actions-wrapper">
        <li class="action-items table-search ma-2">
          <v-text-field
            v-model="searchString"
            class="searchbar"
            hide-details
            dense
            clearable
            solo
            label="Search by Project"
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
        </li>
        <li class="action-items">
          <div class="text-center">
            <v-menu
              v-model="filterMenu"
              :close-on-content-click="false"
              max-width="400px"
              min-width="400px"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-btn color="white" v-on="on" class="ma-3">
                  <v-icon>mdi-filter</v-icon>filter
                </v-btn>
              </template>
              <v-card class="pb-4">
                <v-list>
                  <v-list-item>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Project Name</div>
                      <v-select
                        v-model="filters.projectName"
                        placeholder="Select Project"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        item-text="projectName"
                        item-value="projectName"
                        :items="projectNames"
                      ></v-select>
                    </v-list-item-title>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Customer Name</div>
                      <v-select
                        v-model="filters.customer"
                        placeholder="Select Customer"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        item-text="name"
                        item-value="id"
                        :items="customers"
                      ></v-select>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Client Name</div>
                      <v-select
                        v-model="filters.client"
                        placeholder="Select Client"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        item-text="name"
                        item-value="id"
                        :items="clients"
                      ></v-select>
                    </v-list-item-title>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Status</div>
                      <v-select
                        v-model="filters.status"
                        placeholder="Select Status"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        :items="statusList"
                      ></v-select>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Project Type</div>
                      <v-select
                        v-model="filters.projectType"
                        placeholder="Select Project Type"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        item-text="projectType"
                        item-value="projectType"
                        :items="projectTypes"
                      ></v-select>
                    </v-list-item-title>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Industry</div>
                      <v-select
                        v-model="filters.industry"
                        placeholder="Select Industry"
                        outlined
                        background-color="white"
                        dense
                        filled
                        hide-details
                        :items="industries"
                      ></v-select>
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">Start Time</div>
                      <v-dialog
                        ref="sdDialog"
                        v-model="filterStartDateModal"
                        :return-value.sync="filters.startTime"
                        persistent="false"
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="filters.startTime"
                            placeholder="Start Date"
                            readonly
                            outlined
                            background-color="white"
                            dense
                            filled
                            hide-details
                            v-on="on"
                            append-icon="mdi-calendar-month"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="filters.startTime" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="filterStartDateModal = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.sdDialog.save(filters.startTime)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-list-item-title>
                    <v-list-item-title
                      class="d-flex flex-column align-start ma-2"
                    >
                      <div class="subtitle-2 mb-1">End Time</div>
                      <v-dialog
                        ref="edDialog"
                        v-model="filterEndDateModal"
                        :return-value.sync="filters.endTime"
                        persistent="false"
                        width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="filters.endTime"
                            placeholder="End Date"
                            readonly
                            outlined
                            background-color="white"
                            dense
                            filled
                            hide-details
                            v-on="on"
                            append-icon="mdi-calendar-month"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="filters.endTime" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="filterEndDateModal = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.edDialog.save(filters.endTime)"
                            >OK</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#0e07b5" outlined @click="closeFiltersMenu"
                    >Cancel</v-btn
                  >
                  <v-btn color="#0e07b5" outlined @click="resetAppliedFilters"
                    >Reset</v-btn
                  >
                  <v-btn
                    color="#0e07b5"
                    class="mr-4 white--text"
                    @click="applyFilters"
                    >Apply</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-menu>
          </div>
        </li>
        <v-spacer></v-spacer>
        <li class="action-items">
          <v-btn
            depressed
            dark
            large
            color="#0e07b5"
            class="ma-3"
            @click="addProject"
          >
            <v-icon>mdi-plus</v-icon>Add New Project
          </v-btn>
          <v-dialog v-model="dialog" max-width="600px">
            <v-card class="pa-3">
              <div
                id="mdiv"
                @click="
                  () => {
                    dialog = false;
                  }
                "
              >
                <div class="mdiv">
                  <div class="md"></div>
                </div>
              </div>
              <v-card-title class="justify-center">
                <span class="title indigo--text">{{ dialogTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <div class="subtitle-2 mb-1">
                    Project Name
                    <span class="red--text asterisk">*</span>
                  </div>
                  <v-text-field
                    background-color="white"
                    v-model="project.projectName"
                    :rules="fieldRules"
                    outlined
                    dense
                    required
                  ></v-text-field>
                  <div class="item-row">
                    <div class="left">
                      <div class="subtitle-2 mb-1">Project Type</div>
                      <v-text-field
                        background-color="white"
                        v-model="project.projectType"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                    <div class="right">
                      <div class="subtitle-2 mb-1">
                        Project Status
                        <span class="red--text asterisk">*</span>
                      </div>
                      <v-select
                        background-color="white"
                        v-model="project.status"
                        :items="statusList"
                        placeholder="Select"
                        :rules="[(v) => !!v || 'Value is required']"
                        outlined
                        dense
                        required
                      ></v-select>
                    </div>
                  </div>
                  <div class="item-row mb-1">
                    <div class="left">
                      <div class="subtitle-2 mb-1">
                        Customer Name
                        <span class="red--text asterisk" v-if="!newCustomer"
                          >*</span
                        >
                      </div>
                    </div>
                    <div
                      class="right d-flex flex-row justify-end"
                      v-show="customers.length > 0"
                    >
                      <v-btn
                        text
                        small
                        color="#0e07b5"
                        class="text-capitalize"
                        @click="newCustomer = !newCustomer"
                      >
                        {{
                          newCustomer
                            ? "Or Select Existing Customer"
                            : "+ Add New Customer"
                        }}
                      </v-btn>
                    </div>
                  </div>

                  <div class="field-container" v-if="newCustomer">
                    <div class="subtitle-2 mb-1">
                      Customer Name
                      <span class="red--text asterisk">*</span>
                    </div>
                    <v-text-field
                      background-color="white"
                      v-model="customerTemplate.name"
                      :rules="fieldRules"
                      outlined
                      dense
                      required
                    ></v-text-field>
                    <div class="item-row">
                      <div class="left">
                        <div class="subtitle-2 mb-1">Contact Name</div>
                        <v-text-field
                          background-color="white"
                          v-model="customerTemplate.contactName"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                      <div class="right">
                        <div class="subtitle-2 mb-1">Contact Email</div>
                        <v-text-field
                          background-color="white"
                          v-model="customerTemplate.email"
                          :rules="emailRules"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                    </div>
                  </div>
                  <v-select
                    v-else
                    background-color="white"
                    :items="customers"
                    item-text="name"
                    item-value="id"
                    v-model="project.customer"
                    placeholder="Select"
                    :rules="[(v) => !!v || 'Value is required']"
                    required
                    dense
                    outlined
                  ></v-select>

                  <div class="item-row mb-1">
                    <div class="left">
                      <div class="subtitle-2">
                        Client Name
                        <span class="red--text asterisk" v-if="!newClient"
                          >*</span
                        >
                      </div>
                    </div>
                    <div
                      class="right d-flex flex-row justify-end"
                      v-show="clients.length > 0"
                    >
                      <v-btn
                        text
                        small
                        color="#0e07b5"
                        class="text-capitalize"
                        @click="newClient = !newClient"
                      >
                        {{
                          newClient
                            ? "Or Select Existing Client"
                            : "+ Add New Client"
                        }}
                      </v-btn>
                    </div>
                  </div>
                  <div class="field-container" v-if="newClient">
                    <div class="subtitle-2 mb-1">
                      Client Name
                      <span class="red--text asterisk">*</span>
                    </div>
                    <v-text-field
                      background-color="white"
                      v-model="clientTemplate.name"
                      :rules="fieldRules"
                      outlined
                      dense
                      required
                    ></v-text-field>
                    <div class="item-row">
                      <div class="left">
                        <div class="subtitle-2 mb-1">Contact Name</div>
                        <v-text-field
                          background-color="white"
                          v-model="clientTemplate.contactName"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                      <div class="right">
                        <div class="subtitle-2 mb-1">Contact Email</div>
                        <v-text-field
                          background-color="white"
                          v-model="clientTemplate.email"
                          :rules="emailRules"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="item-row">
                      <div class="left">
                        <div class="subtitle-2 mb-1">
                          Industry
                          <span class="red--text asterisk">*</span>
                        </div>
                        <v-select
                          background-color="white"
                          :items="industries"
                          v-model="clientTemplate.industry"
                          placeholder="Select"
                          :rules="[(v) => !!v || 'Value is required']"
                          required
                          dense
                          outlined
                        ></v-select>
                      </div>
                      <div class="right"></div>
                    </div>
                  </div>
                  <v-select
                    v-else
                    background-color="white"
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    v-model="project.client"
                    placeholder="Select"
                    :rules="[(v) => !!v || 'Value is required']"
                    required
                    dense
                    outlined
                  ></v-select>
                  <v-checkbox
                    v-model="project.isPayable"
                    label="Is Project Billable?"
                  ></v-checkbox>
                  <v-row>
                    <v-col cols="12" sm="2">
                      <v-avatar v-if="project.logo">
                        <img :src="project.logo" alt="logo" />
                      </v-avatar>
                      <v-skeleton-loader
                        v-else
                        :boilerplate="true"
                        type="avatar"
                        class="mx-auto"
                      ></v-skeleton-loader>
                      <h4 :style="{ 'padding-left': '8px' }">Logo</h4>
                    </v-col>
                    <v-col cols="12" sm="7">
                      <v-file-input
                        v-model="projectLogo"
                        placeholder="Upload Project logo"
                        label="Image input"
                        prepend-icon="mdi-camera"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <div class="my-2">
                        <v-btn
                          :disabled="uploading || !projectLogo"
                          small
                          color="primary"
                          @click="uploadImage"
                          >{{ uploading ? "Uploading" : "Upload" }}</v-btn
                        >
                      </div>
                    </v-col>
                  </v-row>

                  <div class="subtitle-2 text-center">Project Color</div>
                  <v-color-picker
                    class="ma-auto mb-5"
                    v-model="project.color"
                    hide-inputs
                  ></v-color-picker>

                  <v-btn
                    dark
                    color="#0e07b5"
                    class="mb-3"
                    @click="addedEmployees.push({ id: '', rate: 0 })"
                  >
                    <v-icon dark>mdi-plus</v-icon>Add Member
                  </v-btn>
                  <div
                    class="team-wrapper"
                    v-for="(member, index) in [
                      ...project.employees,
                      ...addedEmployees
                    ]"
                    :key="index"
                  >
                    <div class="item-row">
                      <div class="left">
                        <v-select
                          v-model="member.id"
                          background-color="white"
                          :items="appUsers"
                          :item-text="getEmployeeName"
                          item-value="userId"
                          placeholder="Select Member"
                          :rules="[(v) => !!v || 'Item is required']"
                          required
                          outlined
                          dense
                        ></v-select>
                      </div>
                      <div class="right">
                        <div class="item-row">
                          <div class="left">
                            <v-text-field
                              background-color="white"
                              v-model="member.rate"
                              type="number"
                              placeholder="Rate"
                              outlined
                              dense
                              required
                              :rules="[
                                (v) => {
                                  if (v || v == 0) {
                                    return true;
                                  } else {
                                    return 'Item is required';
                                  }
                                }
                              ]"
                            ></v-text-field>
                          </div>
                          <div class="right">
                            <v-btn
                              class="mx-2"
                              icon
                              color="red"
                              @click="removeEmployee(index)"
                              :disabled="project.employees.length == 0"
                            >
                              <v-icon dark>mdi-close</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#0e07b5" outlined @click="closeDialog"
                  >Close</v-btn
                >
                <v-btn
                  :disabled="!valid"
                  color="#0e07b5"
                  class="mr-4 white--text"
                  @click="dialogType == 'add' ? saveProject() : updateProject()"
                  >{{ dialogType == "add" ? "save" : "update" }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </li>
      </ul>
    </div>
    <div class="table">
      <data-table
        :index="index"
        :dense="dense"
        :multiSelect="multiSelect"
        :fixedHeader="fixedHeader"
        :height="height"
        :headers="headers"
        :content="filteredDataArray"
        :isCheckable="true"
        :clients="clients"
        :customers="customers"
        :searchString="searchString"
        @update="updateItem"
        @delete="deleteItem"
      ></data-table>
    </div>
  </div>
</template>

<script>
import HeaderTile from "@/components/HeaderTile.vue";
import DataTable from "@/components/DataTable.vue";

import firebase from "../firebase";
import { firestore } from "firebase";
import fcmServerkey from "../fcm_serverkey";

export default {
  name: "Projects",
  components: {
    HeaderTile,
    DataTable
    // eslint-disable-next-line no-undef
    // 'DatePick' : Datepicker
  },
  data() {
    return {
      searchString: "",
      filterMenu: false,
      filterEndDateModal: false,
      filterStartDateModal: false,
      filters: {
        projectName: "",
        customer: "",
        client: "",
        startTime: "",
        endTime: "",
        status: "",
        industry: "",
        projectType: ""
      },
      filteredDataArray: [],

      customerTemplate: {
        name: "",
        contactName: "",
        email: ""
      },
      clientTemplate: {
        name: "",
        contactName: "",
        email: "",
        industry: ""
      },
      newClient: false,
      newCustomer: false,
      statusList: ["In-Progress", "Upcoming", "Completed", "Discarded"],
      removedEmployees: [],
      addedEmployees: [],
      uploading: false,
      projectLogo: null,
      valid: true,
      dialogType: "",
      dialogTitle: "",
      projectsRef: null,
      industryRef: null,
      usersRef: null,
      customerRef: null,
      clientRef: null,
      tiles: [],
      index: false,
      dense: true,
      multiSelect: true,
      fixedHeader: true,
      height: "auto",
      dialog: false,
      headers: [
        {
          name: "projectName",
          label: "Project Name",
          type: "text"
        },
        {
          name: "customer",
          label: "Customer Name",
          type: "customer"
        },
        {
          name: "client",
          label: "Client Name",
          type: "client"
        },
        {
          name: "startTime",
          label: "Start Date",
          type: "date"
        },
        {
          name: "status",
          label: "Status",
          type: "status"
        },
        {
          name: "industry",
          label: "Industry",
          type: "text"
        },
        {
          name: "projectType",
          label: "Project Type",
          type: "text"
        },
        {
          name: "employees",
          label: "Team",
          type: "team"
        },
        {
          label: "Action",
          type: "action"
        }
      ],
      projects: [],
      appUsers: [],
      clients: [],
      customers: [],
      industries: [],
      fieldRules: [
        (v) => !!v || "Value is required",
        (v) => (v && v.length >= 3) || "Value must be greater than 3 characters"
      ],
      emailRules: [(v) => /.+@.+\..+/.test(v) || !v || "E-mail must be valid"],
      project: {
        client: "",
        status: "Upcoming",
        isPayable: false,
        logo: "",
        customer: "",
        employees: [],
        endTime: null,
        industry: "",
        projectName: "",
        projectType: "",
        startTime: null,
        color: "#0C3859FF"
      }
    };
  },
  created() {
    this.projectsRef = firebase.firestore().collection("projects");
    this.projectsRef.onSnapshot((querySnapshot) => {
      this.projects = [];
      querySnapshot.forEach((doc) => {
        this.projects.push({
          id: doc.id,
          ...doc.data()
        });
      });
      this.filteredDataArray = this.projects;
      this.populateTiles();
    });

    this.usersRef = firebase.firestore().collection("user");
    this.usersRef.onSnapshot((querySnapshot) => {
      this.appUsers = [];
      querySnapshot.forEach((doc) => {
        this.appUsers.push({
          id: doc.id,
          ...doc.data()
        });
      });
    });

    this.clientRef = firebase.firestore().collection("client");
    this.clientRef.onSnapshot((querySnapshot) => {
      this.clients = [];
      querySnapshot.forEach((doc) => {
        this.clients.push({
          id: doc.id,
          ...doc.data()
        });
      });
      if (this.clients.length == 0) {
        this.newClient = true;
      }
    });

    this.customerRef = firebase.firestore().collection("customer");
    this.customerRef.onSnapshot((querySnapshot) => {
      this.customers = [];
      querySnapshot.forEach((doc) => {
        this.customers.push({
          id: doc.id,
          ...doc.data()
        });
      });
      if (this.customers.length == 0) {
        this.newCustomer = true;
      }
    });

    this.industryRef = firebase.firestore().collection("dropdowns");
    this.industryRef
      .doc("industry")
      .get()
      .then((doc) => {
        let data = doc.data();
        if (data && data.values && data.values.length > 0) {
          this.industries = data.values;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {
    projectNames() {
      return this.projects.filter((obj) => obj.projectName);
    },
    projectTypes() {
      return this.projects.filter((obj) => obj.projectType);
    }
  },
  methods: {
    populateTiles() {
      let activeProjects = 0;
      let upcomingProjects = 0;
      let completedProjects = 0;
      let discardedProjects = 0;
      this.projects.forEach((obj) => {
        if ("status" in obj && obj.status) {
          switch (obj.status) {
            case "In-Progress":
              activeProjects++;
              break;
            case "Upcoming":
              upcomingProjects++;
              break;
            case "Completed":
              completedProjects++;
              break;
            case "Discarded":
              discardedProjects++;
              break;
            default:
              break;
          }
        }
      });
      this.tiles = [
        {
          icon: "mdi-star-outline",
          count: activeProjects,
          name: "Active Projects"
        },
        {
          icon: "mdi-star-outline",
          count: upcomingProjects,
          name: "Upcoming Projects"
        },
        {
          icon: "mdi-star-outline",
          count: completedProjects,
          name: "Completed Projects"
        },
        {
          icon: "mdi-star-outline",
          count: discardedProjects,
          name: "Discarded Projects"
        }
      ];
    },
    closeDialog() {
      this.dialog = false;
      this.addedEmployees = [];
      this.removedEmployees = [];
      this.reset();
    },
    saveProject() {
      let valid = this.validate();
      let self = this;
      this.removedEmployees = [];
      if (valid) {
        this.dialog = false;
        if (this.newCustomer) {
          this.customerRef.add(this.customerTemplate).then((customerRes) => {
            self.project.customer = customerRes.id;
            customerRes.get().then((dataRes) => {
              let custData = dataRes.data();
              if (self.newClient) {
                self.clientRef.add(self.clientTemplate).then((clientRes) => {
                  self.project.client = clientRes.id;
                  self.savingProcess(custData);
                });
              } else self.savingProcess(custData);
            });
          });
        } else if (this.newClient) {
          this.clientRef.add(this.clientTemplate).then((clientRes) => {
            self.project.client = clientRes.id;
            self.savingProcess();
          });
        } else this.savingProcess();
      }
    },
    savingProcess(customerData) {
      let self = this;
      this.project.startTime = new Date().valueOf();
      this.projectsRef.add(this.project).then((res) => {
        self.project.employees.forEach((employee) => {
          self.appUsers.forEach((user) => {
            if (user.userId == employee.id) {
              res.get().then((dataRes) => {
                let projectData = dataRes.data();
                projectData.id = res.id;
                self.addUserProject(
                  user,
                  projectData,
                  employee.rate,
                  customerData
                );
              });
            }
          });
        });
        self.reset();
      });
    },
    removeEmployee(index) {
      if (this.project.employees[index] && this.project.employees[index].id)
        this.removedEmployees.push(this.project.employees[index].id);
      let i = 0;
      this.project.employees = this.project.employees.filter(() => {
        return index != i++;
      });
    },

    async sendNotificationToEmployeeAddedToProject(user, project) {
      // Simple POST request with a JSON body using fetch
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "key=" + fcmServerkey
        },
        body: JSON.stringify({
          notification: {
            title: "New Project",
            body:
              'You have been assigned to project "' + project.projectName + '"'
          },
          data: {
            imageUrl: project.logo,
            click_action: "FLUTTER_NOTIFICATION_CLICK"
          },
          registration_ids: user.fcmTokens
        })
      };
      // debugger;
      await fetch("https://fcm.googleapis.com/fcm/send", requestOptions)
        .then((response) => {
          // debugger;
          return response;
        })
        .then(() => {
          firestore()
            .collection("notifications")
            .add({
              userId: user.userId,
              projectId: project.id,
              projectName: project.projectName,
              imageUrl: project.logo,
              createdAt: new Date().valueOf(),
              read: false,
              title: "Project Assigned",
              clientName: project.client,
              customerName: project.customer,
              description:
                'You have been added to Project "' +
                project.projectName +
                '" by Client "' +
                project.client +
                '"'
            });
        })
        .catch((error) => {
          console.error(error);
        });
    },

    addUserProject(user, project, userRate, customerData) {
      if ("projects" in user && Object.keys(user.projects).length > 0) {
        // if (!Object.prototype.hasOwnProperty.call(user.projects, project.id)) {
        user.projects[project.id] = {
          started: new Date().valueOf(),
          finished: null
          // };
        };
      } else {
        user.projects = {};
        user.projects[project.id] = {
          started: new Date().valueOf(),
          finished: null
        };
      }
      // debugger;
      this.usersRef.doc(user.userId).set(user);

      let customerObj = null;
      this.addedEmployees.forEach((emp) => {
        if (emp.id == user.userId) {
          if (customerData) customerObj = customerData;
          else {
            let projectCustomer = this.customers.find(
              (customer) => customer.id == project.customer
            );
            if (projectCustomer) customerObj = projectCustomer;
          }
          let payload = {
            employeeId: user.userId,
            employeeName: user.firstName + " " + user.lastName,
            projectId: project.id,
            projectName: project.projectName,
            rate: Number(userRate),
            customer: customerObj?.name ?? ""
          };

          this.sendNotificationToEmployeeAddedToProject(user, project).then(
            () => {
              this.projectsRef
                .doc(project.id)
                .get()
                .then((doc) => {
                  doc.ref
                    .collection("Employees")
                    .doc(user.userId)
                    .set(payload);
                })
                .catch((error) => {
                  console.error(error);
                });
            }
          );
        }
      });
    },

    async sendNotificationToEmployeeRemovedFromProject(user, project) {
      // Simple POST request with a JSON body using fetch
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "key=" + fcmServerkey
        },
        body: JSON.stringify({
          registration_ids: user.fcmTokens,
          notification: {
            title: "Project UnAssigned",
            body:
              'You have been unassigned to a project "' +
              project.projectName +
              '"'
          },
          data: {
            click_action: "FLUTTER_NOTIFICATION_CLICK",
            imageUrl: project.logo
          }
        })
      };
      await fetch("https://fcm.googleapis.com/fcm/send", requestOptions)
        .then((response) => response.json())
        .then(() => {
          firestore()
            .collection("notifications")
            .add({
              userId: user.userId,
              projectId: project.id,
              projectName: project.projectName,
              imageUrl: project.logo,
              createdAt: new Date().valueOf(),
              read: false,
              title: "Project UnAssigned",
              clientName: project.client,
              customerName: project.customer,
              description:
                'You have been removed from Project "' +
                project.projectName +
                '" by Client "' +
                project.client +
                '"'
            });
        })
        .catch((error) => {
          console.error(error);
        });
    },

    removeUserProject(employeeId, project) {
      // debugger;
      let projectId = project.id;
      this.appUsers.forEach((user) => {
        if (user.userId == employeeId) {
          // debugger;
          if (user.projects && Object.keys(user.projects).length > 0) {
            let userProject = user.projects[projectId];
            if (userProject) {
              userProject.finished = new Date().valueOf();
              user.projects[projectId] = userProject;
              this.removedEmployees.forEach((emp) => {
                if (emp == user.userId) {
                  this.sendNotificationToEmployeeRemovedFromProject(
                    user,
                    project
                  );
                }
              });
              this.usersRef.doc(user.userId).set(user);
            }
          }
        }
      });
    },

    validate() {
      return this.$refs.form.validate();
    },

    reset() {
      this.removedEmployees = [];
      this.addedEmployees = [];
      this.project = {
        client: "",
        status: "Upcoming",
        isPayable: false,
        logo: "",
        customer: "",
        employees: [],
        endTime: null,
        industry: "",
        projectName: "",
        projectType: "",
        startTime: null,
        color: "#0C3859FF"
      };
      this.customerTemplate = {
        name: "",
        contactName: "",
        email: ""
      };
      this.clientTemplate = {
        name: "",
        contactName: "",
        email: "",
        industry: ""
      };
      this.newClient = false;
      this.newCustomer = false;
      this.resetValidation();
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },
    getEmployeeName(data) {
      let name = data.firstName + " " + data.lastName;
      if (name.trim()) return name.trim();
      else return "Unknown User";
    },
    deleteItem(item) {
      this.projectsRef.doc(item.id).delete();
    },
    updateItem(item) {
      this.dialogType = "update";
      this.dialogTitle = "Update Project";
      for (const key in this.project) {
        if (!Object.prototype.hasOwnProperty.call(item, key)) {
          item[key] = this.project[key];
        }
      }
      this.project = item;
      this.dialog = true;
    },
    addProject() {
      this.dialogType = "add";
      this.dialogTitle = "Add Project";
      this.dialog = true;
    },
    updateProject() {
      // debugger;
      let valid = this.validate();
      let self = this;
      if (valid) {
        this.dialog = false;

        if (this.newCustomer) {
          this.customerRef.add(this.customerTemplate).then((customerRes) => {
            self.project.customer = customerRes.id;
            customerRes.get().then((dataRes) => {
              let custData = dataRes.data();
              if (self.newClient) {
                self.clientRef.add(self.clientTemplate).then((clientRes) => {
                  self.project.client = clientRes.id;
                  self.updatingProcess(custData);
                });
              } else self.updatingProcess(custData);
            });
          });
        } else if (this.newClient) {
          this.clientRef.add(this.clientTemplate).then((clientRes) => {
            self.project.client = clientRes.id;
            self.updatingProcess();
          });
        } else this.updatingProcess();
      }
    },

    updatingProcess(customerData) {
      let self = this;
      let project = this.project;
      let id = project.id;
      if (this.removedEmployees.length > 0) {
        this.removedEmployees.forEach((employeeId) => {
          this.removeUserProject(employeeId, project);
        });
        this.removedEmployees = [];
      }
      if (this.addedEmployees.length > 0) {
        this.addedEmployees.forEach((employee) => {
          project.employees.push(employee);
        });
        // this.addedEmployees = [];
      }
      let projectData = JSON.parse(JSON.stringify(this.project));
      // delete this.project.id;
      this.projectsRef
        .doc(id)
        .set(this.project)
        .then(() => {
          self.project.employees.forEach((employee) => {
            self.appUsers.forEach((user) => {
              if (user.userId == employee.id) {
                self.addUserProject(
                  user,
                  projectData,
                  employee.rate,
                  customerData
                );
              }
            });
          });
          self.project = JSON.parse(JSON.stringify(self.project));
          self.reset();
        });
    },

    uploadImage() {
      this.uploading = true;
      let storageRef = firebase.storage().ref("project/logos");
      let file = this.projectLogo;
      let name = new Date().valueOf() + "-" + file.name;
      let metadeta = {
        contentType: file.type
      };

      let task = storageRef.child(name).put(file, metadeta);
      task
        .then((snapshot) => snapshot.ref.getDownloadURL())
        .then((url) => {
          this.uploading = false;
          this.projectLogo = null;
          this.project.logo = url;
          this.project = JSON.parse(JSON.stringify(this.project));
        })
        .catch((error) => {
          console.error(error);
        });
    },

    resetAllFilters() {
      for (const key in this.filters) {
        this.filters[key] = "";
      }
    },
    closeFiltersMenu() {
      this.filterEndDateModal = false;
      this.filterStartDateModal = false;
      this.filterMenu = false;
    },
    applyFilters() {
      let self = this;
      this.filteredDataArray = [];
      this.filterEndDateModal = false;
      this.filterStartDateModal = false;
      this.filterMenu = false;
      this.filteredDataArray = this.projects.filter((data) => {
        let found = false;
        for (const key in self.filters) {
          const val = self.filters[key];
          if (val) {
            if (key == "startTime") {
              let date1 = new Date(data.startTime);
              let date2 = new Date(val);
              if (
                date1.getFullYear() == date2.getFullYear() &&
                date1.getMonth() == date2.getMonth() &&
                date1.getDate() == date2.getDate()
              )
                found = true;
              else {
                found = false;
                break;
              }
            } else if (key == "endTime") {
              let date1 = new Date(data.endTime);
              let date2 = new Date(val);
              if (
                date1.getFullYear() == date2.getFullYear() &&
                date1.getMonth() == date2.getMonth() &&
                date1.getDate() == date2.getDate()
              )
                found = true;
              else {
                found = false;
                break;
              }
            } else if (data[key] == val) found = true;
            else {
              found = false;
              break;
            }
          }
        }
        return found;
      });
    },
    resetAppliedFilters() {
      this.filterEndDateModal = false;
      this.filterStartDateModal = false;
      this.filterMenu = false;
      this.resetAllFilters();
      this.filteredDataArray = this.projects;
    }
  }
};
</script>

<style scoped>
.page-wrapper {
  padding: 1vh 1vw;
}
.tiles {
  padding: 10px 0px;
  align-items: center;
  justify-content: space-evenly;
  flex-wrap: wrap;
  height: auto;
}

.tile-wrapper {
  flex: 1;
}

.actions-wrapper {
  width: 100%;
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px;
  padding: 0px;
  flex-wrap: wrap;
}

.table-search {
  width: 100%;
  min-width: 200px;
  max-width: 600px;
}

.v-input--selection-controls {
  margin-top: 0px;
}

/* ///////////////////////////////////// */

.field-container {
  background: #f5f6f7;
  padding: 10px;
  box-sizing: border-box;
  height: auto;
  margin-bottom: 20px;
}

.item-row {
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  height: auto;
}

.item-row .left {
  position: relative;
  width: 50%;
  float: left;
  padding-right: 5px;
  box-sizing: border-box;
}

.item-row .right {
  position: relative;
  width: 50%;
  float: right;
  padding-left: 5px;
  box-sizing: border-box;
}

.asterisk {
  font-size: 15px;
  font-weight: 900;
  font-family: Candara, Arial, Helvetica, sans-serif;
}

.team-wrapper {
  height: auto;
  box-sizing: border-box;
  height: 70px;
  margin-top: 20px;
}

#mdiv {
  width: 25px;
  height: 25px;
  float: right;
  /* background-color: red; */
  /* border: 1px solid black; */
}

.mdiv {
  height: 25px;
  width: 2px;
  margin-left: 12px;
  background-color: grey;
  transform: rotate(45deg);
  z-index: 1;
}

.md {
  height: 25px;
  width: 2px;
  background-color: grey;
  transform: rotate(90deg);
  z-index: 2;
}
</style>
